import { render, staticRenderFns } from "./RelatedCategoryVersioneMedia.vue?vue&type=template&id=57131b84"
import script from "./RelatedCategoryVersioneMedia.vue?vue&type=script&lang=js"
export * from "./RelatedCategoryVersioneMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports